import { useState, useEffect } from "react";

const COINGECKO_URL = "https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd";
const POLL_INTERVAL = 60_000; // 60 seconds

export function useSolPrice(): number | null {
    const [price, setPrice] = useState<number | null>(null);

    useEffect(() => {
        const controller = new AbortController();

        function fetchPrice() {
            fetch(COINGECKO_URL, { signal: controller.signal })
                .then((r) => (r.ok ? r.json() : null))
                .then((data) => {
                    const p = data?.solana?.usd;
                    if (p) setPrice(p);
                })
                .catch(() => {});
        }

        fetchPrice();
        const interval = setInterval(fetchPrice, POLL_INTERVAL);
        return () => {
            controller.abort();
            clearInterval(interval);
        };
    }, []);

    return price;
}
